import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Destiny from '../api/Destiny.js';
import Car from '../api/Car.js';
import { TailSpin } from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import SuccessModal from '../components/successModal.js';

/*
| 14-11-2025 | Tiago | CAR-91 - Retirar 'Data de Chegada'
*/

function CreateTripModal({ isOpen, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        date: '',
        time: '',
        date2: '',
        time2: '',
        departure: '',
        destination: '',
        seats: '',
        km: '',
    });

    const [destiniesList, setDestiniesList] = useState(null);
    const [hasCar, setHasCar] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [dateError, setDateError] = useState('');
    const previousInputRef = useRef(null);

    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        const loadInitialData = async () => {
            await getDestiniesList();

            try {
                await Car.get(localStorage.getItem('userID'));
                setHasCar(true);
            } catch (err) {
                setHasCar(false);
            }
        };

        loadInitialData();
    }, []);

    const handleFocus = (e) => {
        if (
            previousInputRef.current &&
            previousInputRef.current !== e.target
        ) {
            previousInputRef.current.blur();
        }

        previousInputRef.current = e.target;

        setTimeout(() => {
            e.target.focus();

            if (e.target.showPicker) {
                e.target.showPicker();
            }
        }, 50);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'date') {
            setDateError(
                value && value < today
                    ? 'Não é possível marcar viagens em datas passadas.'
                    : ''
            );
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
            ...(name === 'date' ? { date2: value } : {}),
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const submitData = {
            ...formData,
            date2: formData.date,
        };

        if (submitData.date < today) {
            setDateError(
                'Não é possível marcar viagens em datas passadas.'
            );
            return;
        }

        setDateError('');

        if (
            submitData.date &&
            submitData.time &&
            submitData.date2 &&
            submitData.time2 &&
            submitData.departure &&
            submitData.destination &&
            submitData.seats &&
            submitData.km
        ) {
            onSubmit(submitData);
            setModalOpen(true);
        }
    };

    const getDestiniesList = async () => {
        try {
            const { data } = await Destiny.list();

            const sourceData = Array.isArray(data) ? data : [];

            const transformedData = sourceData
                .filter((destiny) => destiny && destiny.destino)
                .map((destiny) => ({
                    id: destiny.id,
                    name: destiny.destino,
                }));

            setDestiniesList(transformedData);

            setFormData((prev) => ({
                ...prev,
                departure: transformedData[0]?.name || '',
                destination:
                    transformedData[1]?.name ||
                    transformedData[0]?.name ||
                    '',
            }));
        } catch (err) {
            console.log('error on getting destinies list:', err);
            setDestiniesList([]);
        }
    };

    if (!isOpen) {
        return null;
    }

    const isLoading = destiniesList === null || hasCar === null;
    const hasDestinies =
        Array.isArray(destiniesList) && destiniesList.length > 0;

    return (
        <>
            <div className="modal">
                <div className="modal-content">
                    <span className="close" onClick={onClose}>
                        &times;
                    </span>

                    {isLoading && (
                        <div className="loading-container">
                            <TailSpin
                                height="80"
                                width="80"
                                color="#0c1534"
                                ariaLabel="loading"
                            />
                        </div>
                    )}

                    {!isLoading && (
                        <form onSubmit={handleSubmit}>
                            {hasCar && hasDestinies && (
                                <>
                                    <div className="floating-label">
                                        <input
                                            type="date"
                                            id="date"
                                            name="date"
                                            value={formData.date}
                                            min={today}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                            onFocus={handleFocus}
                                        />

                                        <label
                                            htmlFor="date"
                                            className={
                                                formData.date ? 'filled' : ''
                                            }
                                        >
                                            Data de Partida
                                        </label>
                                    </div>

                                    {dateError && (
                                        <p className="error-message2">
                                            {dateError}
                                        </p>
                                    )}

                                    <div className="floating-label">
                                        <input
                                            type="time"
                                            id="time"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                            onFocus={handleFocus}
                                        />

                                        <label
                                            htmlFor="time"
                                            className={
                                                formData.time ? 'filled' : ''
                                            }
                                        >
                                            Hora de Partida
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            type="time"
                                            id="time2"
                                            name="time2"
                                            value={formData.time2}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                            onFocus={handleFocus}
                                        />

                                        <label
                                            htmlFor="time2"
                                            className={
                                                formData.time2 ? 'filled' : ''
                                            }
                                        >
                                            Hora de Chegada
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <select
                                            id="departure"
                                            name="departure"
                                            value={formData.departure}
                                            onChange={handleChange}
                                            required
                                        >
                                            {destiniesList.map((destiny) => (
                                                <option
                                                    key={destiny.id}
                                                    value={destiny.name}
                                                >
                                                    {destiny.name}
                                                </option>
                                            ))}
                                        </select>

                                        <label
                                            htmlFor="departure"
                                            className="filled select-label"
                                        >
                                            Partida
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <select
                                            id="destination"
                                            name="destination"
                                            value={formData.destination}
                                            onChange={handleChange}
                                            required
                                        >
                                            {destiniesList.map((destiny) => (
                                                <option
                                                    key={destiny.id}
                                                    value={destiny.name}
                                                >
                                                    {destiny.name}
                                                </option>
                                            ))}
                                        </select>

                                        <label
                                            htmlFor="destination"
                                            className="filled select-label"
                                        >
                                            Destino
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            type="number"
                                            id="seats"
                                            name="seats"
                                            value={formData.seats}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                        />

                                        <label
                                            htmlFor="seats"
                                            className={
                                                formData.seats ? 'seats' : ''
                                            }
                                        >
                                            Lugares Disponíveis
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input
                                            type="number"
                                            id="km"
                                            name="km"
                                            value={formData.km}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                        />

                                        <label
                                            htmlFor="km"
                                            className={
                                                formData.km ? 'km' : ''
                                            }
                                        >
                                            KMs
                                        </label>
                                    </div>
                                </>
                            )}

                            {hasCar && !hasDestinies && (
                                <div>
                                    <FontAwesomeIcon
                                        icon={faTriangleExclamation}
                                        className="warning-icon"
                                    />

                                    <p className="error-message2">
                                        Não existem destinos disponíveis para
                                        criar uma viagem.
                                    </p>
                                </div>
                            )}

                            {!hasCar && (
                                <div>
                                    <FontAwesomeIcon
                                        icon={faTriangleExclamation}
                                        className="warning-icon"
                                    />

                                    <p className="error-message2">
                                        Antes de criar uma viagem adicione um
                                        carro ao seu perfil{' '}
                                        <Link to="/settings">aqui</Link>
                                    </p>
                                </div>
                            )}

                            {hasCar && hasDestinies && (
                                <div className="modal-footer">
                                    <button
                                        className="btn-primary"
                                        type="submit"
                                    >
                                        MARCAR VIAGEM
                                    </button>
                                </div>
                            )}
                        </form>
                    )}
                </div>
            </div>

            <SuccessModal
                open={modalOpen}
                handleClose={() => setModalOpen(false)}
                title="Viagem criada com sucesso"
                message="A sua viagem foi criada com sucesso."
            />
        </>
    );
}

export default CreateTripModal;